import { createSlice } from "@reduxjs/toolkit";
import { save_tokens_constant, asyncStatus } from "../../utils/asyncStatus";
import { check_auth, login_service_auth } from "../../services/authentication";
import {
  success_toast_message,
  error_toast_message,
} from "../../utils/toast_message";
import {
  getAllCustomers,
  updateCustomerStatus,
  updateCustomerTags,
} from "../../services/CustomerManagment";

const initialState = {
  // GET ALL STORES >>>>>>>>>>>>>
  get_all_customers_status: asyncStatus.IDLE,
  get_all_customers_data: null,
  get_all_customers_error: null,

  // GET STORE BY ID >>>>>>>>>>>>>
  get_store_by_id_status: asyncStatus.IDLE,
  get_store_by_id_data: null,
  get_store_by_id_error: null,

  // EDIT STORE >>>>>>>>>>>>>
  update_customer_status_status: asyncStatus.IDLE,
  update_customer_status_data: null,
  update_customer_status_error: null,

  update_customer_tags_status: asyncStatus.IDLE,
  update_customer_tags_data: null,
  update_customer_tags_error: null,
};

const CustomerManagementSlice = createSlice({
  name: "customer_management",
  initialState,
  reducers: {
    setIdleStatus(state) {
      state.get_all_customers_status = asyncStatus.IDLE;
    },
  },
  extraReducers: (builder) => {
    // GET ALL STORES >>>>>>>>>>>>>
    builder.addCase(getAllCustomers.pending, (state, action) => {
      state.get_all_customers_status = asyncStatus.LOADING;
    });

    builder.addCase(getAllCustomers.fulfilled, (state, { payload }) => {
      state.get_all_customers_status = asyncStatus.SUCCEEDED;
      state.get_all_customers_data = payload?.data;
    });

    builder.addCase(getAllCustomers.rejected, (state, action) => {
      state.get_all_customers_status = asyncStatus.ERROR;
      state.get_all_customers_error = action.error;
      error_toast_message(action.error.message);
    });

    // EDIT Customer >>>>>>>>>>>>>
    builder.addCase(updateCustomerStatus.pending, (state, action) => {
      state.update_customer_status_status = asyncStatus.LOADING;
    });

    builder.addCase(updateCustomerStatus.fulfilled, (state, { payload }) => {
      state.update_customer_status_status = asyncStatus.SUCCEEDED;
      state.update_customer_status_data = payload.data;
      success_toast_message("Store status updated successfully");
    });

    builder.addCase(updateCustomerStatus.rejected, (state, action) => {
      state.update_customer_status_status = asyncStatus.ERROR;
      state.update_customer_status_error = action.error;
      error_toast_message(action.error.message);
    });

    // EDIT Cusotmer >>>>>>>>>>>>>
    builder.addCase(updateCustomerTags.pending, (state, action) => {
      state.update_customer_tags_status = asyncStatus.LOADING;
    });

    builder.addCase(updateCustomerTags.fulfilled, (state, { payload }) => {
      state.update_customer_tags_status = asyncStatus.SUCCEEDED;
      state.update_customer_tags_data = payload.data;
      success_toast_message("Store status updated successfully");
    });

    builder.addCase(updateCustomerTags.rejected, (state, action) => {
      state.update_customer_tags_status = asyncStatus.ERROR;
      state.update_customer_tags_error = action.error;
      error_toast_message(action.error.message);
    });
  },
});

export const { setIdleStatus } = CustomerManagementSlice.actions;

export default CustomerManagementSlice.reducer;
